import RequestHelper, {ActionAnswer, Pagination} from "../utils/RequestsHelper"
import {AxiosPromise} from "axios"

export interface SkuData {
    name: string
    product_name: string
    category_name: string
    id: number
    product_id: number
    category_id: number
    url: string
}
export interface SkuLogData {
    to_export: object,
    prices: object,
    stocks: object
    logs: LogData | null
}
export interface LogData {
    stock_answer: null | string
    update_price_answer: null | string
    export_product_answer: null | string
}
export default class ProductsLogApi {

    public static getProductsList(page?: number, onPage?: number, query?: string): AxiosPromise<ActionAnswer<Pagination<SkuData[]>>> {
        return RequestHelper.send("get", "productLogs", {
            page, pageCount: onPage, query
        })
    }

    public static getProduct(product_id: number, sku_id: number): AxiosPromise<ActionAnswer<SkuLogData>> {
        return RequestHelper.send("get", "productLogs&action=product", {product_id, sku_id})
    }
}